import { BaseElement, defineElement } from '@webtides/element-js';

/**
 * @property {string} for
 * @property {boolean} selected
 */
export default class TabLink extends BaseElement {
    properties() {
        return {
            for: undefined,
            selected: false,
        };
    }

    connected() {
        // Accessibility
        this.setAttribute('role', 'tab');
        this.setAttribute('id', `tab-link-${this.for}`);
        this.setAttribute('aria-controls', `tab-panel-${this.for}`);
        this.setAttribute('aria-selected', `${this.selected}`);
        this.setAttribute('tabindex', this.selected ? '0' : '-1');
    }

    afterUpdate() {
        // Accessibility
        this.setAttribute('aria-selected', `${this.selected}`);
        this.setAttribute('tabindex', this.selected ? '0' : '-1');
    }

    watch() {
        return {
            selected: (selected) => {
                this.toggleAttribute('active', selected);
            },
        };
    }

    events() {
        return {
            this: {
                click: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.hasAttribute('disabled')) return;
                    this.dispatch('tab-select', { selected: this.for }, true, true, true);
                },
                focus: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.hasAttribute('disabled')) return;
                    this.dispatch('tab-select', { selected: this.for }, true, true, true);
                },
            },
        };
    }
}

defineElement('tab-link', TabLink);
